module.exports = __webpack_public_path__ + "img/game-avatar-1.618a56fe.png";